// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__25kti","insightsList":"newBusinessInsightsMenu_insightsList__yZMi0","active":"newBusinessInsightsMenu_active__2cc5D"};